<template>
    <b-card class="block__objectiveList">
      <header>
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>          
            {{title}}
          </PuSkeleton>
          </p>
        <p class="number">
          <PuSkeleton :loading="isLoading" :count="1" width='20px'>          
            {{objectifNumber}}
          </PuSkeleton>          
        </p>
      </header>

      <div class="sep"></div>

      <b-list-group>
        <b-list-group-item v-for="(list,index) of lists" :key="index">
          <div class="entete">
            <div class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>              
                {{list.title}}
              </PuSkeleton>
            </div>
            <div class="number">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>              
                {{list.number}}
              </PuSkeleton>
            </div>
          </div>
          <div class="label">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>                          
              {{list.label}}
            </PuSkeleton>
          </div>
          
          <PuSkeleton :loading="isLoading" :count="1" width='200px'>
            <div class="wrapper">
                <b-progress :value="list.value" :class="list.color"></b-progress>
                <p class="value" :class="list.color">{{list.value}}%</p>
            </div>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>

export default {
name:"wrapperObjectiveList",
  props:{
    title:{
      type:String,
      default:'Bonus'
      },
    objectifNumber:{
      type:Number,
      default:0
      },
    lists:{
      type:Array,
      },
  },
data(){
  return {
    isLoading:true,
  }
},
mounted () {
},
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  } 
}
</script>